/**
 * 隐藏手机号码
 * @param val {Number, String} 转换的字符串对象
 * @param retain {Number} 保留位数
 * @return {String}
 */
import moment from "moment";

let formatDate = function (data, unit = "MM/DD HH:mm") {
    return data ? moment(data).format(unit) : ""
}

let checkSpecialChar = function (str) {
    let charReg = /&nbsp|&#34|&quot/g;
    return charReg.test(str)
}
export {
    formatDate,
    checkSpecialChar
}